import { render, staticRenderFns } from "./VmsForm.vue?vue&type=template&id=5c033bec&"
import script from "./VmsForm.vue?vue&type=script&lang=js&"
export * from "./VmsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports